import z from 'zod';
import {firestoreTimestampSchema} from '../_other';

export const tradeMessageWriteSchema = z.object({
  note: z.string().default(''),
  screenshotStoragePath: z.string().min(1).optional(),
  createdAt: firestoreTimestampSchema,
});

export type TradeMessageWrite = z.infer<typeof tradeMessageWriteSchema>;
